<template>
  <section
    id="get-in-touch"
    :class="[
      'tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-ap-white-smoke tw-w-full',
      'tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop',
      'apDesktop:tw-pt-[167px] tw-pt-[64px]',
    ]"
  >
    <div
      :class="[
        'tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-white apTablet2:tw-pt-[160px] tw-pt-[64px] hello-there-container apTablet2:tw-px-0 tw-px-6',
        'apDesktop2:tw-max-w-[1700px] apTablet:tw-max-w-[584px] apTablet2:tw-max-w-[1280px]',
        'apDesktop:tw-mb-[-60px] tw-mb-[-26px]'
      ]"
    >
      <div
        class="tw-text-ap-nero tw-text-hello-there-mobile apTablet2:tw-text-hello-there-desktop tw-text-center apTablet:tw-mx-8 tw-mx-0"
      >
        Hello there.
      </div>
      <div
        id="description-text"
        class="tw-text-body-mobile apDesktop:tw-text-body-desktop tw-max-w-[640px] tw-pt-8 apDesktop:tw-pb-[80px] tw-pb-[64px] apDesktop:tw-px-0 tw-px-10 tw-leading-6 apTablet2:tw-leading-8 tw-text-ap-nero"
      >
        If you think we'd be a good fit for your project, we'd love to hear from
        you. Send us an email with a description your project and we'll get back
        to you as soon as we can.<br><br>Tip: The more you tell us, the
        better the value we can add to your project.
      </div>
      <div class="tw-flex tw-flex-col apDesktop2:tw-gap-14 tw-gap-10">
        <div
          id="form-field"
          :class="[
            'tw-grid tw-grid-1 apDesktop2:tw-grid-cols-3 tw-gap-6 apDesktop:tw-max-w-full apTablet:tw-max-w-[456px] apDesktop:tw-w-full apTablet:tw-w-full',
          ]"
        >
          <TextForm
            v-model:data="contactUs.name"
            placeholder="Full name"
            title="Your name"
            :is-forcelight-mode="true"
          />
          <TextForm
            id="refWidth"
            v-model:data="contactUs.email"
            placeholder="email@example.com"
            title="Email"
            :is-forcelight-mode="true"
          />
          <DropDownForm
            v-model:data="contactUs.organization_type"
            :title="'How would you describe your organisation?'"
            placeholder="Please select"
            :options="organisationType"
            :is-force-light-mode="true"
          />
        </div>
        <div
          class="apDesktop2:tw-grid apDesktop2:tw-grid-cols-3 tw-gap-4 apDesktop2:tw-pb-[104px] tw-pb-[64px] tw-w-full"
        >
          <div />
          <div
            :class="[
              'tw-flex tw-items-center tw-px-6 tw-py-4 tw-cursor-pointer apDesktop:tw-h-16 tw-h-12',
              'tw-rounded-xl tw-text-ap-nobel',
              'tw-outline tw-outline-ap-gainsboro tw-outline-offset-[-2px] tw-outline-1',
              {
                '!tw-bg-ap-dodger-blue !tw-text-white tw-transition-all tw-duration-300 !tw-outline-none hover:tw-opacity-80':
                  enableButton,
              },
            ]"
            :style="{
              background:
                'url(' +
                $cdn(
                  enableButton
                    ? 'icons/shared/icon_paperplane_light.svg'
                    : 'icons/shared/icon_paperplane.svg'
                ) +
                ')',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '95% center',
            }"
            @click="onClickContinueButton"
          >
            Continue
          </div>
          <div />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { ContactUs } from '../../model/interfaces/ContactUs';
import DropDownForm from './DropDownForm.vue';
import TextForm from './TextForm.vue';

const contactUs = ref(ContactUs.create());
const buttonWidth = ref(500);
const enableButton = computed(() => {
  return (
    contactUs.value.isValidEmail() &&
    contactUs.value.isValidName() &&
    contactUs.value.isValidOrganizationType()
  );
});
const organisationType = ref([
  'Startup',
  'Small/Medium Business',
  'Large Corporation',
  'Non-profit',
  'Other',
]);

const emit = defineEmits(['clickContinue']);

const onClickContinueButton = () => {
  if (enableButton.value) {
    emit('clickContinue', contactUs.value);
  }
};

function onResize() {
  const refWidth = document.getElementById('refWidth');
  const refFormField = document.getElementById('description-text');
  const formField = document.getElementById('form-field');
  if (refWidth) {
    buttonWidth.value = refWidth.offsetWidth;
  }

  if (refFormField && formField) {
    if (window.innerWidth < 1440) {
      formField.style.width = refFormField.offsetWidth + 'px';
    } else {
      formField.style.width = 'auto';
    }
  }
}

onMounted(() => {
  onResize();
  window.addEventListener('resize', onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});
</script>

<style scoped>
.hello-there-container {
  width: 100%;
}

@media screen and (min-width: 375px) and (max-width: 1023px) {
  .hello-there-container {
    width: 92%;
  }

}
</style>
